import { useMemo } from 'react';
import { useVideoThumbnail } from '../../../hooks/useVideoThumbnail';

interface VideoThumbnailProps {
  videoUrl: string;
  alt?: string;
  className?: string;
  fallbackImageUrl?: string;
  timePosition?: number;
}

/**
 * A component that renders a thumbnail for a video URL
 */
export default function VideoThumbnail({
  videoUrl,
  alt = 'Video thumbnail',
  className = '',
  fallbackImageUrl = '/images/content-submission/media-placeholder.jpeg',
  timePosition,
}: VideoThumbnailProps) {
  const { thumbnail, isLoading, error } = useVideoThumbnail(videoUrl, timePosition);

  // Use the generated thumbnail or fallback to the default image
  const imageUrl = useMemo(() => {
    if (isLoading || error || !thumbnail) {
      return fallbackImageUrl;
    }
    return thumbnail;
  }, [thumbnail, isLoading, error, fallbackImageUrl]);

  return <img src={imageUrl} alt={alt} className={className} />;
}
